const VEHICLE_YEAR = [
  {
    key: '',
    label: 'Tahun Kendaraan',
    value: '',
  },
  {
    key: '1',
    label: '1994',
    value: '1994',
  },
  {
    key: '2',
    label: '1995',
    value: '1995',
  },
  {
    key: '3',
    label: '1996',
    value: '1996',
  },
  {
    key: '4',
    label: '1997',
    value: '1997',
  },
  {
    key: '5',
    label: '1998',
    value: '1998',
  },
  {
    key: '6',
    label: '1999',
    value: '1999',
  },
  {
    key: '7',
    label: '2000',
    value: '2000',
  },
  {
    key: '8',
    label: '2001',
    value: '2001',
  },
  {
    key: '9',
    label: '2002',
    value: '2002',
  },
  {
    key: '10',
    label: '2003',
    value: '2003',
  },
  {
    key: '11',
    label: '2004',
    value: '2004',
  },
  {
    key: '12',
    label: '2005',
    value: '2005',
  },
  {
    key: '13',
    label: '2006',
    value: '2006',
  },
  {
    key: '14',
    label: '2007',
    value: '2007',
  },
  {
    key: '15',
    label: '2008',
    value: '2008',
  },
  {
    key: '16',
    label: '2009',
    value: '2009',
  },
  {
    key: '17',
    label: '2010',
    value: '2010',
  },
  {
    key: '18',
    label: '2011',
    value: '2011',
  },
  {
    key: '19',
    label: '2012',
    value: '2012',
  },
  {
    key: '20',
    label: '2013',
    value: '2013',
  },
  {
    key: '21',
    label: '2014',
    value: '2014',
  },
  {
    key: '22',
    label: '2015',
    value: '2015',
  },
  {
    key: '23',
    label: '2016',
    value: '2016',
  },
  {
    key: '24',
    label: '2017',
    value: '2017',
  },
  {
    key: '25',
    label: '2018',
    value: '2018',
  },
  {
    key: '26',
    label: '2019',
    value: '2019',
  },
]

export default VEHICLE_YEAR